module.exports = __webpack_public_path__ + "static/media/pro-tip-offers.2e75109d.png";